import {
  PhysicalWrapper,
  WeightIcon,
  DimensionsIcon,
  DimensionsText,
  DimensionsInput,
  DimensionsWrapper,
  MeasurementIndicator,
} from './styles';

const PhysicalEdit = ({ totalWeightDry, length, height, width, onChange }) => {
  return (
    <PhysicalWrapper>
      <WeightIcon />
      <DimensionsInput
        value={totalWeightDry}
        name='totalWeightDry'
        onChange={onChange}
        type='number' pattern="[0-9]*"
      />
      <MeasurementIndicator>t</MeasurementIndicator>
      <DimensionsIcon />
      <DimensionsWrapper>
        <DimensionsInput
          value={length}
          name='length'
          onChange={onChange}
          type='number' pattern="[0-9]*"
        />
        <MeasurementIndicator>m</MeasurementIndicator>
        <DimensionsText>x</DimensionsText>
        <DimensionsInput
          value={width}
          name='width'
          onChange={onChange}
          type='number' pattern="[0-9]*"
        />
        <MeasurementIndicator>m</MeasurementIndicator>
        <DimensionsText>x</DimensionsText>
        <DimensionsInput
          value={height}
          name='height'
          onChange={onChange}
          type='number' pattern="[0-9]"
        />
        <MeasurementIndicator>m</MeasurementIndicator>
      </DimensionsWrapper>
    </PhysicalWrapper>
  );
};

export default PhysicalEdit;
